import { FusionSettingsApi, useFusionSettingsAPI } from "melco-shared-logic";
import { useCallback } from "react";
import { Settings } from "./useSettings";

const initialValue = {
  settings: undefined,
};

export const useFusionSettings = () => {
  const handleRequest = useCallback(async (api: FusionSettingsApi) => {
    const settings = await api.settingsGetFusionDefaultSetting();
    return { settings };
  }, []);

  return useFusionSettingsAPI<Settings>({
    initialValue,
    handleRequest,
  });
};
